import { PortalWrapper } from 'app/App.styles';
import styled, { from } from 'theme';

export const ActivateEmailWrapper = styled(PortalWrapper)`
  .activate-email__content {
    padding: 1rem 0;

    ${from('md')} {
      padding: 4rem 0;
    }
  }

  .activate-email__login {
    color: ${props => props.theme.variables.colors.red};
    margin-top: 1rem;
    display: block;

    &:hover {
      text-decoration: underline;
    }
  }
`;
